export function PreviewHistoryQrcode(props: {}) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Group">
        <g id="Group_2">
          <path
            id="Path"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 5H8.33333V8.33333H5V5Z"
            stroke="#12192B"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Path_2"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 11.666H8.33333V14.9993H5V11.666Z"
            stroke="#12192B"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Path_3"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15 8.33398H11.6667V5.00065H15V8.33398Z"
            stroke="#12192B"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Path_4"
            d="M13.3626 13.3032C13.3789 13.3195 13.3789 13.3459 13.3626 13.3621C13.3464 13.3784 13.32 13.3784 13.3037 13.3621C13.2874 13.3459 13.2874 13.3195 13.3037 13.3032C13.32 13.2869 13.3464 13.2869 13.3626 13.3032"
            stroke="#12192B"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Path_5"
            d="M11.6961 11.6372C11.7124 11.6535 11.7124 11.6799 11.6961 11.6961C11.6799 11.7124 11.6535 11.7124 11.6372 11.6961C11.6209 11.6799 11.6209 11.6535 11.6372 11.6372C11.6535 11.6209 11.6799 11.6209 11.6961 11.6372"
            stroke="#12192B"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Path_6"
            d="M11.6961 14.9712C11.7124 14.9875 11.7124 15.0138 11.6961 15.0301C11.6799 15.0464 11.6535 15.0464 11.6372 15.0301C11.6209 15.0138 11.6209 14.9875 11.6372 14.9712C11.6535 14.9549 11.6799 14.9549 11.6961 14.9712"
            stroke="#12192B"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Path_7"
            d="M15.0296 14.9712C15.0459 14.9875 15.0459 15.0138 15.0296 15.0301C15.0134 15.0464 14.987 15.0464 14.9707 15.0301C14.9544 15.0138 14.9544 14.9875 14.9707 14.9712C14.987 14.9549 15.0134 14.9549 15.0296 14.9712"
            stroke="#12192B"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Path_8"
            d="M17.9166 6.64899V3.75065C17.9166 2.82982 17.1707 2.08398 16.2499 2.08398H13.3516"
            stroke="#12192B"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Path_9"
            d="M6.6485 2.08398H3.75016C2.82933 2.08398 2.0835 2.82982 2.0835 3.75065V6.64899"
            stroke="#12192B"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Path_10"
            d="M2.0835 13.3516V16.2499C2.0835 17.1707 2.82933 17.9166 3.75016 17.9166H6.6485"
            stroke="#12192B"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Path_11"
            d="M13.3516 17.9166H16.2499C17.1707 17.9166 17.9166 17.1707 17.9166 16.2499V13.3516"
            stroke="#12192B"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Path_12"
            d="M15.0296 11.6372C15.0459 11.6535 15.0459 11.6799 15.0296 11.6961C15.0134 11.7124 14.987 11.7124 14.9707 11.6961C14.9544 11.6799 14.9544 11.6535 14.9707 11.6372C14.987 11.6209 15.0134 11.6209 15.0296 11.6372"
            stroke="#12192B"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
}
